import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        eDocAdditionalConfig: {
            initOnRender: false
        },
        eDocTableActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        eDocTableRowActions: [
            {
                btn_text: '<i class="far fa-file-alt"></i>',
                title: 'Melléklet nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'printAttachment'
            }
        ],
        eDocTableSearchFields: [
            {
                name: "paciensIdType",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "paciensId",
                label: "Páciens azonosító",
                formSize: 4,
                formVisible: true,
                formType: "text"
            },
            {
                name: "fromDate",
                label: "Időszak kezdete",
                description: "Alapértelmezetten aktuális nap",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
            {
                name: "toDate",
                label: "Időszak vége",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
            {
                name: "breakGlass",
                label: "Sürgősségi adatlekérés",
                description: "Sürgős lekérdezés esetén indoklás szükséges!",
                formSize: 4,
                formVisible: true,
                formType: 'checkbox'
            },
            {
                label: "Sürgősségi adatlekérés oka",
                name: "breakGlassOk",
                formSize: 4,
                formVisible: true,
                formType: 'text'
            }
        ],
        eDocTableHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "docType",
                label: "Dok. típus",
                visibility: false
            },
            {
                name: "docTypeName",
                label: "Dokumentum típus",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "docNev",
                label: "Dokumentum",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "docStatusz",
                label: "Dok. státusz",
                visibility: false
            },
            {
                name: "docStatuszName",
                label: "Státusz",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "docFeltoltoIntezmeny",
                label: "Intézmény",
                visibility: false
            },
            {
                name: "docFeltoltoSzervezetiEgyseg",
                label: "Szervezeti egység",
                visibility: false
            },
            {
                name: "docFeltoltoUser",
                label: "Feltöltő",
                visibility: false
            },
            {
                name: "feltoltesIdeje",
                label: "Feltöltés ideje",
                slot_name: "created_on_format",
                visibility: true,
                sort: true
            },
            {
                name: "forrasDocId",
                label: "forrasDocId",
                visibility: false
            },
            {
                name: "parentDocId",
                label: "parentDocId",
                visibility: false
            },
            {
                name: "megjegyzes",
                label: "Megjegyzés",
                visibility: false
            },
            {
                name: "attachments",
                label: "Mellékletek",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
